import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';
import { lazyGettext } from '@eb/lazy-gettext';

import { Button, SIZE_BLOCK } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';
import { LogoGoogle } from '@eb/eds-iconography';

import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE } from './constants';
import { injectScriptTag } from './utils';

import './GoogleLoginButton.scss';

export default class GoogleLoginButton extends Component {
    static propTypes = {
        onSocialConnectVerified: PropTypes.func,
        onSocialConnectNotAuthorized: PropTypes.func,
        onLoadComplete: PropTypes.func,
        onClick: PropTypes.func,
    };

    componentDidMount() {
        injectScriptTag({
            doc: document,
            id: 'google-id-auth',
            src: 'https://apis.google.com/js/platform.js',
            onLoad: this.googleInit,
        });
    }

    googleInit = () => {
        const { clientId, scope } = this.props;

        /*eslint-disable no-undef*/
        if (gapi) {
            gapi.load('auth2', function () {
                gapi.auth2 &&
                    gapi.auth2.init({
                        client_id: clientId,
                        scope: scope,
                    });
            });
        }
    };

    // signOut = () => {
    //     /*eslint-disable no-undef*/
    //     if (gapi) {
    //         const auth2 = gapi.auth2 && gapi.auth2.getAuthInstance();

    //         auth2.signOut().then(function () {
    //             console.log('User signed out.');
    //         });
    //     }
    // };

    onSignInClicked = () => {
        const { onSocialConnectVerified } = this.props;

        /*eslint-disable no-undef*/
        if (gapi) {
            const auth2 = gapi.auth2 && gapi.auth2.getAuthInstance();

            gapi.load('auth2', function () {
                auth2.signIn().then(
                    (googleUser) => {
                        console.log(
                            'Logged in as: ' +
                                googleUser?.getBasicProfile()?.getName(),
                        );

                        onSocialConnectVerified({
                            accessToken: googleUser.getAuthResponse().id_token,
                            email: googleUser.getBasicProfile().getEmail(),
                            firstName: googleUser
                                .getBasicProfile()
                                .getGivenName(),
                            lastName: googleUser
                                .getBasicProfile()
                                .getFamilyName(),
                            picture: googleUser.getBasicProfile().getImageUrl(),
                            sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
                        });
                    },
                    // function (error) {
                    //     console.log('user failed to sign in');
                    //     // this.onFailure
                    // },
                );
            });
        }
    };

    render() {
        const { buttonGoogleText } = this.props;
        const buttonText =
            buttonGoogleText || lazyGettext('Continue with Google');

        return (
            <div className="google-login__container">
                <Button
                    type="button"
                    size={SIZE_BLOCK}
                    onClick={this.onSignInClicked}
                >
                    <div className="google-login__icon">
                        <Icon type={<LogoGoogle />} size="small" />
                    </div>
                    {buttonText}
                </Button>
            </div>
        );
    }
}
